import {
  ClientWebAppProjectEnum,
  EnvConfiguration,
  EnvironmentType,
} from '@sleipai/sleip-ngrx-store';

export const environment: EnvConfiguration = {
  production: false,
  hmr: false,
  env: 'dev' as EnvironmentType,
  firebase: {
    apiKey: 'AIzaSyCJM6fFXBNRLhunlTMoBkp_0pFMkG0NAqo',
    authDomain: 'sleip-dev.firebaseapp.com',
    databaseURL: 'https://sleip-dev.firebaseio.com',
    projectId: 'sleip-dev',
    storageBucket: 'sleip-dev.appspot.com',
    messagingSenderId: '616706935186',
    appId: '1:616706935186:web:ba3552ff42ecd03efd994b',
    measurementId: 'G-2YK3QTEVRZ',
  },
  algolia: {
    appId: 'D51WX9518Y',
    apiKey: '97dc228bb5b7d0a5d7fd4802c03996f0',
    horseIndex: 'dev_horses',
    userIndex: 'dev_users',
    groupIndex: 'dev_groups',
  },
  googleAnalyticsId: 'G-2YK3QTEVRZ',
  clientWebAppProject: ClientWebAppProjectEnum.LIDSKJALV,
};
